import { render, staticRenderFns } from "./eComplaintComments.vue?vue&type=template&id=3d6e9336"
import script from "./eComplaintComments.vue?vue&type=script&lang=js"
export * from "./eComplaintComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports